// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__XkGLH","noFoundTextContainer":"NotFoundPage_noFoundTextContainer__KADDy","logo":"NotFoundPage_logo__7Fxdx"};